import { render, staticRenderFns } from "./LabelStrokeWeightIcon.vue?vue&type=template&id=0c441dc8&"
import script from "./LabelStrokeWeightIcon.vue?vue&type=script&lang=js&"
export * from "./LabelStrokeWeightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports